import { useState } from 'react';
import type { MouseEvent } from 'react';
import { t } from '../../i18n';
import { store } from '../../state/store';
import { getOrchestratorRef } from '../messageList/MessageList.helpers';

export function DrivingModeKeypad() {
  const [digits, setDigits] = useState('');

  const handleDigit = (digit: string) => {
    setDigits((prev) => (prev.length < 20 ? prev + digit : prev));
  };

  const handleSend = () => {
    if (!digits) return;
    const orchestrator = getOrchestratorRef();
    if (orchestrator) orchestrator.sendMessage(digits, [], true);
    setDigits('');
    store.setDrivingMode({ keypadOpen: false });
  };

  const handleBackdropClick = (e: MouseEvent<HTMLDivElement>) => {
    if ((e.target as HTMLElement).classList.contains('driving-keypad-backdrop')) {
      store.setDrivingMode({ keypadOpen: false });
    }
  };

  return (
    <div className="driving-keypad-backdrop" onClick={handleBackdropClick}>
      <div className="driving-keypad">
        <div className="driving-keypad-display" dir="ltr">
          <span className="driving-keypad-digits">{digits}</span>
          <span className="driving-keypad-cursor">|</span>
        </div>
        <div className="driving-keypad-hint">{t('keypadHint')}</div>
        <div className="driving-keypad-grid">
          {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((digit) => (
            <button
              key={digit}
              className="driving-keypad-btn"
              onClick={() => handleDigit(digit)}
            >
              {digit}
            </button>
          ))}
          <button
            className="driving-keypad-btn driving-keypad-backspace"
            onClick={() => setDigits((prev) => prev.slice(0, -1))}
          >
            ⌫
          </button>
          <button className="driving-keypad-btn" onClick={() => handleDigit('0')}>0</button>
          <button className="driving-keypad-btn driving-keypad-send" onClick={handleSend}>
            {t('keypadSend')}
          </button>
        </div>
        <button
          className="driving-keypad-close"
          onClick={() => store.setDrivingMode({ keypadOpen: false })}
        >
          {t('keypadClose')}
        </button>
      </div>
    </div>
  );
}
